import { Zap, Layout, Database, Server, Shield, Code } from "lucide-react";

export const FEATURES = [
  {
    icon: Zap,
    title: "Lightning Fast",
    description:
      "Built with Vite for fast development and production builds.",
  },
  {
    icon: Layout,
    title: "Modern UI Components",
    description:
      "Beautiful and accessible components powered by Shadcn and Tailwind CSS.",
  },
  {
    icon: Database,
    title: "Type-Safe ORM",
    description:
      "Robust database operations with DrizzleORM and PostgreSQL via NeonDB.",
  },
  {
    icon: Server,
    title: "Fast Backend",
    description:
      "Backend powered by HonoJS with built-in TypeScript support.",
  },
  {
    icon: Shield,
    title: "Authentication Ready",
    description:
      "Secure authentication system with custom email and password based login.",
  },
  {
    icon: Code,
    title: "Full TypeScript",
    description:
      "End-to-end type safety with TypeScript and Zod validation throughout.",
  },
];
